import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { FeedbackContainer } from '../feedback-container';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        spellCategory: function (_a) {
            var spellCategory = _a.spellCategory;
            return ({
                width: 4,
                height: '100%',
                backgroundColor: palette.spellCategories[spellCategory]
            });
        },
        content: ({
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            fontSize: 10,
        }),
    });
});
export var FeedbackEffectContainer = function (props) {
    var classes = useStyles(props);
    return (React.createElement(FeedbackContainer, { left: React.createElement("div", { className: classes.spellCategory }), right: React.createElement("div", { className: classes.content }, props.children) }));
};
